'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getVideoProxyUrl } from '@/shared/lib/proxy-url';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import styles from './SecHero.module.scss';
import { CTAButton } from '../CTAButton';
export function SecHero() {
  const $ = _c(40);
  const t = useTranslations("intro");
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = getVideoProxyUrl(`/commerce/static/intro/clip/${locale}/main.mp4`) ?? "";
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const heroVideoSrc = t0;
  const heroVideoPoster = `/intro/hero-poster-${locale}.jpg`;
  const [mountVideo, setMountVideo] = useState(false);
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const w = window as Window & typeof globalThis & {
        requestIdleCallback?: (cb: () => void) => number;
        cancelIdleCallback?: (id: number) => void;
      };
      let idleId = null;
      let timeoutId = null;
      if (typeof w.requestIdleCallback === "function") {
        idleId = w.requestIdleCallback(() => setMountVideo(true));
      } else {
        timeoutId = setTimeout(() => setMountVideo(true), 200);
      }
      return () => {
        if (idleId !== null && typeof w.cancelIdleCallback === "function") {
          w.cancelIdleCallback(idleId);
        }
        if (timeoutId !== null) {
          clearTimeout(timeoutId);
        }
      };
    };
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const handleSampleClick = _temp;
  let t3;
  if ($[4] !== heroVideoPoster) {
    t3 = <Image className={styles.video} src={heroVideoPoster} alt="" fill={true} priority={true} sizes="100vw" />;
    $[4] = heroVideoPoster;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== heroVideoPoster || $[7] !== heroVideoSrc || $[8] !== mountVideo) {
    t4 = mountVideo ? <video className={styles.video} src={heroVideoSrc} poster={heroVideoPoster} autoPlay={true} loop={true} muted={true} playsInline={true} preload="none" /> : null;
    $[6] = heroVideoPoster;
    $[7] = heroVideoSrc;
    $[8] = mountVideo;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.gradientTop} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4) {
    t6 = <div className={styles.videoLayer} aria-hidden="true">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("hero.eyebrow");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <p className={styles.eyebrow}>{t7}</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("hero.heading");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <h1 className={styles.heading}>{t9}</h1>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("hero.cta");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <CTAButton variant="primary">{t11}</CTAButton>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("hero.sample");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <button type="button" onClick={handleSampleClick} className={styles.sampleButton}>{t13}</button>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t12 || $[31] !== t14) {
    t15 = <div className={styles.ctaRow}>{t12}{t14}</div>;
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t10 || $[34] !== t15 || $[35] !== t8) {
    t16 = <div className={styles.inner}>{t8}{t10}{t15}</div>;
    $[33] = t10;
    $[34] = t15;
    $[35] = t8;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16 || $[38] !== t6) {
    t17 = <section id="hero" data-section="hero" className={styles.hero}>{t6}{t16}</section>;
    $[37] = t16;
    $[38] = t6;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp() {
  document.querySelector("#sample-preview")?.scrollIntoView({
    behavior: "smooth"
  });
}